import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'
import { IconApp } from '@shared/components'
import { CompactNumberPipe } from '@shared/pipes/compact-number/compact-number-pipe'

@Component({
  selector: 'coins-badge',
  imports: [IconApp, CompactNumberPipe],
  templateUrl: './coins-badge.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClasses()'
  }
})
export class CoinsBadge {
  coins = input.required<number>()
  type = input<string>('pts')
  size = input<'small' | 'normal'>('normal')
  showType = input<boolean>(true)

  protected hostClasses = computed(() => {
    const base = 'shadow-black-inset flex items-center gap-1 rounded-full bg-neutral-100'
    const sizeClasses = this.size() === 'small' ? 'px-2 py-0.5' : 'px-2.5 py-1'
    return `${base} ${sizeClasses}`
  })
}
